import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-cards.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSCardLink = props => {
  const {
    children
  } = props;
  const childrenArray = React.Children.toArray(children);
  const firstChild = childrenArray[0];
  const decoratedFirstChild = React.cloneElement(firstChild, {
    className: getClassNameList(firstChild.props.className, 'uitk-card-link')
  }, jsx("span", {
    className: "is-visually-hidden",
    children: firstChild.props.children
  }));
  if (!childrenArray || childrenArray.length !== 1) {
    console.warn(`UitkCardLink uses the first child element. ${childrenArray.length} children found.`);
  }
  return decoratedFirstChild;
};
EGDSCardLink.displayName = 'EGDSCardLink';
// Temporary, unstable
const EGDSCardAlohaLink = EGDSCardLink;
export { EGDSCardAlohaLink, EGDSCardLink };